import { Link } from 'react-router-dom';

import photo from '../../img/fotos/Foto_Sobre_Mi.jpg';

import { useIdioma } from '../../context/IdiomaContext';

import './SobreMiInicio.css';

function SobreMiInicio() {
  const { t } = useIdioma();

  return (
    <section
      id="sobre-mi-inicio"
      className="sobre-mi-inicio"
    >
      <div className="sobre-mi-inicio-contenido">
        <p className="sobre-mi-inicio-etiqueta">
          {t('sobreMiInicio.etiqueta')}
        </p>

        <h2>
          {t('sobreMiInicio.titulo')}
        </h2>

        <p className="sobre-mi-inicio-texto">
          {t('sobreMiInicio.descripcion')}
        </p>

        <div className="sobre-mi-inicio-botones">
          <Link
            to="/contacto"
            className="sobre-mi-contacto"
          >
            {t(
              'sobreMiInicio.botonContacto'
            )}
          </Link>

          <Link
            to="/sobre-mi"
            className="sobre-mi-enlace"
          >
            {t(
              'sobreMiInicio.botonSaberMas'
            )}{' '}
            →
          </Link>
        </div>
      </div>

      <div className="sobre-mi-inicio-imagen">
        <img
          src={photo}
          alt={t('sobreMiInicio.imagenAlt')}
        />
      </div>
    </section>
  );
}

export default SobreMiInicio;